export function creditCardFormReducer(state, action) {
    switch (action.type) {
        case 'open':
            return Object.assign(Object.assign({}, state), { mode: action.mode, card: action.card, origin: action.origin || '' });
        case 'close':
            return {
                mode: null,
                card: null,
                origin: '',
            };
        default:
            throw new Error();
    }
}
export function locMockReducer(state, action) {
    const { type, payload } = action;
    switch (type) {
        case 'update':
            return Object.assign(Object.assign({}, state), payload);
        default:
            throw new Error();
    }
}
